import * as yup from 'yup';
import { ImageDataValidation, ContentImageDataValidation } from 'helpers/validations';

const achievementsValidation = yup.object().shape({
  title: yup.string().trim().required('Title is a required field').max(20, 'Number of characters should be less than 20 for the title'),
  description: yup.string().trim().required('Description is a required field').max(80, 'Number of characters should be less than 80 for the description'),
});

const statisticsValidation = yup.object().shape({
  title: yup.string().trim().required('Title is a required field'),
  description: yup.string().trim().required('Description is a required field'),
});

const updateProfileFormValidation = yup.object().shape({
  firstName: yup.string().trim().required('First name is a required field'),
  lastName: yup.string().trim().required('Last name is a required field'),
  email: yup.string().trim().email().required()
    .label('Email'),
  profileImg: ImageDataValidation,
  profileImgUrl: yup.string().trim(),
  bio: yup
    .string()
    .trim()
    .test(
      'is-valid',
      'Bio is a required field',
      (value) => value?.replace(/(<([^>]+)>)/gi, '')?.replace(/[\r\n]+/gm, '').replace(/\s+/g, '').length !== 0,
    )
    .test(
      'length-limit',
      'Bio must have upto 1000 characters',
      (value) => (value?.replace(/(<([^>]+)>)/gi, '')?.replace(/[\r\n]+/gm, '')?.length || 0) <= 1000,
    ),
  category: yup.string().label('Category'),
  currency: yup.string().required().label('Currency'),
  introVideoUrl: yup.string().trim().label('Intro video'),
  thankVideoUrl: yup.string().trim().label('Thank video'),
  rateVideoUrl: yup.string().trim().label('Rate video'),
  accountType: yup.string().trim().required('Account type is a required field'),
  password: yup.string().trim().when('accountType', {
    is: 'password-protected', then: yup.string().trim().required('Password is a required field'),
  }),
  subscriptionFee: yup.number().when('accountType', {
    is: 'subscription',
    then: yup.number().positive().min(1).max(1000000)
      .typeError('Subscription fee per session is a required field')
      .test(
        'maxDigits',
        'Subscription fee per session must have 2 decimal or less',
        (number) => (/^\d+(\.\d{1,2})?$/.test(number?.toString() ?? '')),
      )
      .required()
      .label('Subscription fee'),
  }),
  subscriptionFrequency: yup.string().trim().when('accountType', {
    is: 'subscription', then: yup.string().trim().required('Fee Frequency is a required field'),
  }),
  sponsors: yup.array().of(ContentImageDataValidation).optional(),
  achievements: yup.array().of(achievementsValidation).optional(),
  statistics: yup.array().of(statisticsValidation).optional(),
  badges: yup.array().of(yup.object().shape({
    badgeTitle: yup.string().trim().required('Title is a required field'),
    badgeDescription: yup.string().trim().required('Description is a required field'),
    badgeImgUrl: yup.string().trim().required('Image is a required field'),
  })),
});
export default updateProfileFormValidation;
